import SummaryList           from '@/view/consign/summary/index.vue';
import ContractList          from '@/view/consign/contract/index.vue';
import ContractAdd           from '@/view/consign/contract/view/Add.vue';
import ContractDetail        from '@/view/consign/contract/view/Detail.vue';
import OriginalSettleOrderList from '@/view/consign/original/index.vue';

export default [
    { path: '/consign/summary',                 name: 'ConsignSummaryList',           component: SummaryList,             meta: '代销-汇总单管理' },
    { path: '/consign/contract',                name: 'ConsignContractList',          component: ContractList,            meta: '代销-合同管理' },
    { path: '/consign/contract/add',            name: 'ConsignContractAdd',           component: ContractAdd,             meta: '代销-合同新增' },
    { path: '/consign/contract/detail',         name: 'ConsignContractDetail',        component: ContractDetail,          meta: '代销-合同详情' },
    { path: '/consign/originalSettleOrder',     name: 'ConsignOriginalSettleOrderList', component: OriginalSettleOrderList, meta: '代销-原始结算单查询' },
]
